import React from 'react';
import { HeadCell, Typography } from '../../../../ui-kit';
import NameCell, { NameCellProps } from '../NameCell';
import { Row } from './types';

interface TableCellContentProps extends NameCellProps {
    id: keyof Row;
    hasCollapsibleContent?: boolean;
    isOpen?: boolean;
    setIsOpen?(): void;
    childCount?: number;
    align: HeadCell['align'];
}

const TableCellContent = ({
    id,
    content,
    hasCollapsibleContent,
    isOpen, setIsOpen,
    isChild,
    childCount,
    align,
}: TableCellContentProps) => {
    if (id === 'name') {
        return (
            <NameCell
                content={content}
                childCount={childCount}
                isChild={isChild}
                hasCollapsibleContent={hasCollapsibleContent}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
            />
        );
    }

    return <Typography align={align} variant='body2'>{content}</Typography>;
};

export default TableCellContent;